<template>
    <b-overlay :show="loading" opacity="0.2">
        <div class="row mb-1">
            <div class="col-lg-3 mb-1 mb-lg-0">
                <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>
            </div>
            <div class="col-lg-auto col-12">
                <button class="btn btn-success w-100" v-on:click="getGetSetAssignment()">
                    Sorgula
                </button>
            </div>
        </div>
        <div class="mb-1">
            <vue-perfect-scrollbar>
                <table class="table table-sm table-hover bordered-header mb-1">
                    <thead>
                        <th class="w-12 border text-nowrap">Ad Soyad</th>
                        <th class="w-7 text-nowrap">Kimlik No</th>
                        <th class="w-18 text-nowrap">IBAN</th>
                        <th class="w-7 text-nowrap">Şube</th>
                        <th class="w-7 text-nowrap">Resmi Şube</th>
                        <th class="w-7 text-nowrap">Görevi</th>
                        <th class="w-7 text-nowrap">Sabit Maaş (TL)</th>
                        <th class="w-7 text-nowrap">Giriş Tarihi</th>
                        <th class="w-7 text-nowrap">Yıllık İzin</th>
                        <th class="w-7 text-nowrap">Ücretli İzin</th>
                        <th class="w-7 text-nowrap">Diğer Eksik Günler</th>
                        <th class="w-7 text-nowrap">Ödenecek Avans (TL)</th>
                    </thead>
                    <tbody>
                        <template v-for="(item,index) in items">
                            <tr :key="index">
                                <td colspan="200" class="bg-light text-uppercase">
                                    <h3 class="font-weight-bolder mb-0">
                                        <span class="text-secondary">{{$safe(item,'Type') || '-'}}</span> - 
                                        <template v-if="$safe(item,'EmployeeDepartmentTitle')">
                                            <span class="text-warning">{{ $safe(item,'EmployeeDepartmentTitle') }}</span> - 
                                        </template>
                                        {{$safe(item,'SETName')}}
                                    </h3>
                                </td>
                            </tr>
                            <tr v-for="(data,i) in item.Datas" :key="($safe(data,'IdentityNumber') || '') + index + i">
                                <td class="text-nowrap">{{$safe(data,'FullName') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(data,'IdentityNumber') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(data,'IBAN') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(data,'Branch') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(data,'SGKBranch') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(item,'EmployeeDepartmentTitle') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(data,'NetSalary')}}</td>
                                <td class="text-nowrap">{{$safe(data,'JobEntryDate') || '-'}}</td>
                                <td class="text-nowrap">{{$safe(data,'AnnualHoliday')}}</td>
                                <td class="text-nowrap">{{$safe(data,'PaidHoliday')}}</td>
                                <td class="text-nowrap">{{$safe(data,'OtherLackOfDay')}}</td>
                                <td class="text-nowrap">{{$safe(data,'AdvanceAmount')}}</td>
                            </tr>
                        </template>
                        <tr v-if="(items || []).length == 0">
                            <td colspan="200" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                        </tr>
                    </tbody>
                </table>
            </vue-perfect-scrollbar>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
export default {
    components:{
        BOverlay,
        VuePerfectScrollbar
    },
    props:{
        id:[String,Number],
    },
    data() {
        return {
            date:[],
            loading:false,
            items:[],
        }
    },
    mounted(){
        //this.getGetSetAssignment()
    },
    watch:{
        id(){
            this.getGetSetAssignment()
        }
    },
    methods:{
        getGetSetAssignment(){
            if(this.id != "0" || this.id != 0){
                this.loading = true
                EmployeeOperationsApi.Advance.GetSetAssignment({
                        StartDate:this.date[0] || null,
                        EndDate:this.date[1] || null,
                        EmployeeId:this.id
                    }).then(res=>{
                    this.loading = false
                    if(res.data.Success){
                        this.items = res.data.Data || []
                    }else this.$result(res)
                }).catch(err=>{
                    this.loading = false
                    this.$result(null,err)
                })
            }
        },
    }
}
</script>

<style>

</style>